import React from "react";
import { styles } from "../styles/theme";
import { formatMoney } from "../utils/helpers";

function AuctionSection({ 
  canPlay, 
  bidAmount, 
  setBidAmount, 
  handleBid, 
  topBids,
  gameData,
  totalPlayers,
  allPlayers = []
}) {
  // Calcular cuántos panes se darán en esta ronda
  const currentRound = gameData?.currentRound || 1;
  const totalRounds = gameData?.totalRounds || 6;
  const isFinalRound = currentRound === totalRounds;
  
  // Filtrar solo jugadores activos para calcular panes
  const activePlayers = allPlayers.filter(p => p.active !== false);
  const numActivePlayers = activePlayers.length;
  
  let panesADar;
  if (isFinalRound) {
    panesADar = 1; // Solo 1 ganador en la final
  } else if (numActivePlayers > 8) {
    panesADar = numActivePlayers - 2; // Eliminar 2 cuando hay muchos jugadores
  } else {
    panesADar = numActivePlayers - 1; // Eliminar 1 cuando hay 8 o menos
  }

  // Crear un mapa de ofertas por jugador
  const bidsByPlayer = {};
  topBids.forEach(bid => {
    bidsByPlayer[bid.playerId] = bid.amount;
  });
  
  // Combinar jugadores con sus ofertas y ordenar
  // Eliminar duplicados basándose en el ID del jugador
  const uniquePlayers = activePlayers.reduce((acc, player) => {
    if (!acc.find(p => p.id === player.id)) {
      acc.push(player);
    }
    return acc;
  }, []);

  const playersList = uniquePlayers.map(player => ({
    playerId: player.id,
    playerName: player.name,
    amount: bidsByPlayer[player.id] || 0,
    hasBid: bidsByPlayer[player.id] !== undefined
  })).sort((a, b) => b.amount - a.amount); // Ordenar por oferta descendente

  return (
    <section style={{ marginTop: 16 }}>
    <div style={{ marginTop: 10, fontSize: 12, color: "#c5ffd2" }}>
      <strong>
        {isFinalRound 
          ? `🏆 RONDA FINAL: Solo 1 pan disponible` 
          : `🍞 Esta ronda se darán ${panesADar} panes (Top ${panesADar} ofertas)`
        }
      </strong>
      <ol style={{ marginTop: 4, paddingLeft: 18 }}>
        {playersList.length === 0 && <li>Esperando jugadores...</li>}
        {playersList.map((player, index) => (
          <li key={player.playerId} style={{ 
            marginBottom: 4,
            color: player.hasBid ? "#c5ffd2" : "#888"
          }}>
            {index < panesADar && "🍞 "}
            <strong>{player.playerName}:</strong> {player.hasBid ? formatMoney(player.amount) : "Sin oferta"}
          </li>
        ))}
      </ol>
    </div>
      <h3 style={styles.sectionTitle}>Cuanto ofreces por el pan?</h3>
      <label style={styles.label}>Tu oferta (no puede exceder tu dinero)</label>
      <input
        style={styles.input}
        type="number"
        min="0"
        step="1"
        value={bidAmount}
        onChange={(e) => {
          const value = e.target.value;
          // Solo permitir números enteros (sin decimales)
          if (value === '' || /^\d+$/.test(value)) {
            setBidAmount(value);
          }
        }}
        disabled={!canPlay}
      />
      <button style={styles.button} onClick={handleBid} disabled={!canPlay}>
        Ofertar por el pan
      </button>

    </section>
  );
}

export default AuctionSection;
